import React from 'react';
import { Typography, Box } from '@mui/material';
interface Props extends React.PropsWithChildren {
  title?: string;
}
export default function ColumnHeader(props: Props) {
  const { title, children } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        background: '#fff',
        py: 0,
        px: 5,
        minHeight: '50px',
        borderStyle: 'solid',
        borderWidth: '1px 0',
        borderColor: 'rgb(0, 0, 0, 12%)',
        boxShadow: '0px 2px 5px 0px #0000001A',
      }}
    >
      {children}
      {title ? (
        <Typography
          variant="body2"
          sx={{
            flex: '1 1 auto',
          }}
        >
          <strong>{title}</strong>
        </Typography>
      ) : null}
    </Box>
  );
}
